import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "first-message-date"
}
const _hoisted_2 = { class: "d-flex align-items-end flex-message-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "avatar",
  style: {
                        height: '2em !important'
                    }
}
const _hoisted_4 = {
  key: 1,
  style: {"width":"2em !important"}
}
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "avatar"
}
const _hoisted_8 = {
  key: 2,
  class: "mt-8 text-right message-buttons-wrapper"
}

import {Component, computed, ref} from 'vue';
import MessageTime from "~/chat/vue/widget/tabs/chat/MessageTime.vue";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import {MESSAGE_TYPE_TAB} from "~/chat/ts/data/chat/IMessage";
import ChatMessageTypeTab from "~/chat/vue/widget/tabs/chat/ChatMessageTypeTab.vue";
import ChatMessageTypeText from "~/chat/vue/widget/tabs/chat/ChatMessageTypeText.vue";
import Dictionary from "~/ts/library/Dictionary";
import MessageButton from "~/chat/vue/widget/tabs/chat/MessageButton.vue";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import OperatorAvatar from "~/chat/vue/widget/tabs/chat/OperatorAvatar.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatMessageTypeSticker from "~/chat/vue/widget/tabs/chat/ChatMessageTypeSticker.vue";
import {__} from "~/ts/library/Translate";
import ChatMessageReactions from "~/chat/vue/widget/tabs/chat/ChatMessageReactions.vue";
import ChatMessageReactionSelector from "~/chat/vue/widget/tabs/chat/Reaction/ChatMessageReactionSelector.vue";


const __default__ = {
    name: "ChatMessage"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    showTime: { type: Boolean },
    showDateIfNeeded: { type: Boolean, default: true },
    messageProps: {},
    isLast: { type: Boolean, default: false }
  },
  emits: ["height-increase", "click-on-message-content"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let showEmoji = ref(false);

let isShowReactionSelectorTrigger = computed(() => {
    let message = props.message;
    return !message.isAutoMessage && message.id && ConfigStore.siteParams.value.params.messageReactions?.length > 0;
})


function onMessageButtonClick() {
    MessageStorage.saveMessage(
        props.message.buttonClicked().rawMessage
    );
}

let messageComponent = computed<Component>(() => {
    if (messageType.value == MESSAGE_TYPE_TAB) {
        return ChatMessageTypeTab;
    } else if (props.message.stickerUrl) {
        return ChatMessageTypeSticker;
    } else {
        return ChatMessageTypeText;
    }
});

let messageType = computed(() => {
    return props.message.rawMessage.messageType;
});


let isBlockMessage = computed(() => {
    return props.message.isBlockMessage;
});

function onReplyClick() {
    ChatTabStore.SET_REPLY_TO_MESSAGE_ID(props.message.id);
}

let isDisplayAvatarEnabled = computed(() => {
    return ConfigStore.design.value.dialog.history.displayOperatorAvatar && !ConfigStore.siteParams.value.free && !props.message.isHideOperator;
});

let displayButtons = computed(() => props.isLast && props.message.buttons.length);

if (props.message.isHiddenText) {
    if (!displayButtons.value) {
        MessageStorage.removeMessage(props.message.id);
    }
}


return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
        'chat-message-wrapper',
        _ctx.message.isFromClient ? 'client' : 'operator',
        _ctx.message.isLastMessageOf ? 'last-message-of' : null,
        _ctx.message.isFirstMessageOf ? 'first-message-of' : null
    ])
  }, [
    _renderSlot(_ctx.$slots, "before"),
    (_ctx.message.isDateShowNeeded && _ctx.showDateIfNeeded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.message.dt.toLocaleDateString()), 1))
      : _createCommentVNode("", true),
    (!_ctx.message.isHiddenText)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(isDisplayAvatarEnabled) && !_ctx.message.isFromClient && !_unref(isBlockMessage))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.message.isLastMessageOf)
                    ? (_openBlock(), _createBlock(OperatorAvatar, {
                        key: 0,
                        src: _ctx.message.operator ? _ctx.message.operator.avatar : undefined,
                        name: _ctx.message.operator ? _ctx.message.operator.fio : undefined,
                        size: "2em",
                        "without-border": ""
                      }, null, 8, ["src", "name"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(messageComponent)), _mergeProps({
                class: "message message-text",
                message: _ctx.message,
                "show-date-if-needed": _ctx.showDateIfNeeded,
                margin: !_ctx.message.isHideOperator && !_ctx.message.isBlockMessage,
                onHeightIncrease: _cache[2] || (_cache[2] = ($event: any) => (_unref(emits)('height-increase', $event)))
              }, _ctx.messageProps), _createSlots({ _: 2 }, [
                (_ctx.message.id && !_ctx.message.isAutoMessage)
                  ? {
                      name: "reply-button",
                      fn: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                                    'action-buttons': true,
                                    'is-show-reaction-selector-trigger': _unref(isShowReactionSelectorTrigger)
                                }),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("div", {
                            class: "action-button reply-button cursor-pointer",
                            title: _unref(__)('REPLY'),
                            onClick: onReplyClick
                          }, [
                            _createVNode(SvgIcon, { "icon-name": "reply" })
                          ], 8, _hoisted_6),
                          (_unref(isShowReactionSelectorTrigger))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "action-button reaction-button cursor-pointer",
                                title: "Emoji",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showEmoji) //@ts-ignore
 ? showEmoji.value = !_unref(showEmoji) : showEmoji = !_unref(showEmoji)))
                              }, [
                                _createVNode(SvgIcon, { "icon-name": "smile" })
                              ]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      key: "0"
                    }
                  : undefined,
                (_ctx.message.reactions.length > 0)
                  ? {
                      name: "reactions",
                      fn: _withCtx(() => [
                        _createVNode(ChatMessageReactions, { message: _ctx.message }, null, 8, ["message"])
                      ]),
                      key: "1"
                    }
                  : undefined
              ]), 1040, ["message", "show-date-if-needed", "margin"])), [
                [_directive_on_native, ($event) => _unref(emits)('click-on-message-content', $event), "click"]
              ])
            ])
          ]),
          (_ctx.showTime && !_unref(isBlockMessage))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({'d-flex': !_ctx.message.isFromClient})
              }, [
                (_unref(isDisplayAvatarEnabled) && !_ctx.message.isFromClient)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                  : _createCommentVNode("", true),
                _createVNode(MessageTime, {
                  dt: _ctx.message.dt
                }, null, 8, ["dt"])
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(displayButtons))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass({'message-button': true, 'd-inline-block': _ctx.message.buttons.length > 4})
            }, [
              _createVNode(MessageButton, {
                class: "text-right",
                button: button,
                onClick: onMessageButtonClick
              }, null, 8, ["button"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(ChatMessageReactionSelector, {
      message: _ctx.message,
      popover: "",
      visible: _unref(showEmoji),
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showEmoji) ? (showEmoji).value = $event : showEmoji = $event))
    }, null, 8, ["message", "visible"]),
    _renderSlot(_ctx.$slots, "after")
  ], 2))
}
}

})